import React from 'react';
import { Button } from 'gatsby-theme-apollo';
import { Flex } from '../layout/flex';

const LimitReducer = ({ limit, setSize, onIncreaseLimit, showInterval }) => {
  return (
    <Flex style={{ width: `100%` }}>
      {limit < setSize && (
        <Button primary onClick={onIncreaseLimit} style={{ marginBottom: `10px` }}>
          Show {limit + showInterval >= setSize ? `Rest` : `${showInterval} More`}
        </Button>
      )}
    </Flex>
  );
};

export { LimitReducer };
